import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.to-string.js';
import { __rest } from 'tslib';
import React from 'react';

var Row = function Row(_a) {
  var children = _a.children,
    className = _a.className,
    _a$gap = _a.gap,
    gap = _a$gap === undefined ? 8 : _a$gap,
    _a$cols = _a.cols,
    cols = _a$cols === undefined ? 24 : _a$cols,
    auto = _a.auto,
    _a$element = _a.element,
    element = _a$element === undefined ? 'div' : _a$element,
    rest = __rest(_a, ["children", "className", "gap", "cols", "auto", "element"]);
  var extendedClassName = ['cogs-v10', 'cogs-row', className].filter(Boolean).join(' ');
  var style = {
    gridTemplateColumns: "repeat(" + cols + ", 1fr)",
    gridGap: gap
  };
  if (auto) {
    style.gridTemplateColumns = "repeat(auto-fill, minmax(" + auto + "px, 1fr))";
  }
  return /*#__PURE__*/React.createElement(element, Object.assign(Object.assign({}, rest), {
    className: extendedClassName,
    style: Object.assign(Object.assign({}, rest.style || {}), style)
  }), children);
};

export { Row };
